class MinicartLogin extends HTMLElement {
    constructor() {
        super();
        this.triggerButtons = this.querySelectorAll('button[data-action="switch-form"]');
        this.loginFormElement = this.querySelector('#login-form-container');
        this.recoverFormElement = this.querySelector('#recover-form-container');
        this.emptyCartEl = this.querySelector('#empty-cart-container');
    }

    connectedCallback() {
        this.triggerButtons.forEach(button => {
            button.addEventListener('click', this.switchForm.bind(this));
        });
    }

    switchForm(e) {
        e.preventDefault();
        const target = e.currentTarget;

        if (target.id === 'password-container-toggler') {
            this.emptyCartEl.classList.remove('visible');
            this.loginFormElement.classList.remove('visible');
            this.recoverFormElement.classList.add('visible');
        } else {
            this.recoverFormElement.classList.remove('visible');
            this.emptyCartEl.classList.remove('visible');
            this.loginFormElement.classList.add('visible');
        }
    }

    formSubmitHandler(e) {
        if (!this.registerForm.checkValidity()) {
            e.preventDefault();
            e.stopPropagation();
            for (const el of this.registerForm.querySelectorAll("[required]")) {
                if (!el.reportValidity()) {
                    console.log(!el.reportValidity());
                    return;
                }
            }
        } else if (this.klaviyoCheck.checked) {
            e.preventDefault();

            $('#klaviyo_register_id_email').val($('#register-customer .email-input-field').val());

            const formData = new FormData(this.klaviyoForm);
            const url = this.klaviyoForm.action;

            fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: new URLSearchParams(formData),
            })
                .then(response => response.json())
                .then(data => console.log(data))
                .catch(error => console.error("Error:", error));

            this.registerForm.submit();
        }
    }
}

window.customElements.define("minicart-login", MinicartLogin);
